/* eslint-disable react/display-name */
import * as React from 'react';

const Search = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M11.79,10.24l3.89,3.51a1,1,0,0,1,.06,1.39l-.05,0h0a1.13,1.13,0,0,1-1.53,0l-3.78-3.42a6.43,6.43,0,0,1-4,1.35A6.36,6.36,0,0,1,0,6.82,6.36,6.36,0,0,1,6.4.5a6.37,6.37,0,0,1,6.41,6.32,6.19,6.19,0,0,1-1,3.42ZM6.44,11.32A4.5,4.5,0,0,0,11,6.86a4.53,4.53,0,1,0-4.53,4.46Z"
      style={{ fill: 'inherit' }}
    />
  </svg>
);

export default Search;
